import { DayName } from "uitk-react-date-picker";
import { GtConfig } from "../typings";
import { carTimesValues } from "src/components/flexComponents/WizardCarPWA/config/time/carTimesValues";
import { locKeys } from "src/components/flexComponents/WizardCarPWA/components/l10n";

export const gtConfig: GtConfig = {
  navigation: {
    tabIcon: "",
    tabTitleToken: ""
  },
  heading: {
    fixedTitle: false,
    locToken: ""
  },
  elementId: "",
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "",
    lobKey: ""
  },
  location: {
    origin: {
      inputName: "location",
      icon: "place",
      labelToken: locKeys.gtAirport,
      typeaheadLabelToken: locKeys.gtAirport,
      pwaDialogQueryParam: "origin-car",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    },
    destination: {
      inputName: "hotelName",
      icon: "place",
      labelToken: locKeys.gtProperty,
      typeaheadLabelToken: locKeys.gtProperty,
      pwaDialogQueryParam: "destination-gt",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    }
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    maxDaysRange: 331,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidDepartingDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidReturningDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    midnightBookingOffset: 4,
    start: {
      labelToken: locKeys.gtArrivalDate
    },
    end: {
      labelToken: locKeys.gtDepartureDate
    },
    queryParam: {
      start: "pickUpDate",
      end: "dropOffDate"
    },
    dialogId: "departing-returning"
  },
  carTimesValues,
  form: {
    action: "/ground-transfers/search",
    submitButton: {
      locToken: ""
    }
  }
};
